import { createBaseResourceActions } from '../create-base-resource-actions';
import { MeetingAvailabilityResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[MEETING AVAILABILITY]';
export const meetingAvailabilityActions =
  createBaseResourceActions<MeetingAvailabilityResourceTypeMappings>(
    domainSlug,
  );
